import './HeaderHome.css';
import React, { Component } from 'react';

export default class Header extends Component {
    render() {
        return (

        <>
            <header className='headerCrumb'>
                <div></div>
            </header>
        </>
        )
    }
}
